<div *ngIf="loading">
  <div id="globalLoader" class="global-loader" [ngStyle]="{ 'background-color': sharedService.darkMode ? '#333' : '#fff' }">
    <h1>Loading</h1>
  </div>
</div>

<div fxLayout="column">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <mat-card [style.background-color]="uiData.individual.color" fxFlex="100">
        <h2 class="noMarginHeader">
          <mat-icon>{{ uiData.individual.icon }}</mat-icon> My Individuals
        </h2>
      </mat-card>
    </div>
  </div>

  <mat-card>
    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
      <div fxLayout="row wrap" fxLayoutAlign="space-between start">
        <div fxLayoutGap="5px">
          <strong class="noMarginHeader">Results (<mat-spinner *ngIf="loading" diameter="15"></mat-spinner>{{ loading ? '' : individuals.length }})</strong>

          <mat-form-field style="width: 220px;">
            <input (keyup)="loadIndividuals()" placeholder="Filter name or affiliation" [(ngModel)]="filterString" matInput />
          </mat-form-field>

          <mat-form-field style="width: 125px;">
            <mat-select placeholder="Filter by Status" [formControl]="filteredActive" (selectionChange)="loadIndividuals()">
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Inactive">Inactive</mat-option>
              <mat-option value="Both">Both</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="width: 200px;">
            <mat-select placeholder="Certificate Type" [formControl]="disciplineTypes" multiple (selectionChange)="loadIndividuals()">
              <mat-option *ngFor="let discipline of getDisciplineValues()" [value]="discipline">{{ discipline }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="width: 175px;">
            <input (dateChange)="loadIndividuals()" matInput [matDatepicker]="expirationStartPicker" placeholder="Expiration Start Date" [formControl]="expirationStartDate">
            <mat-datepicker-toggle matSuffix [for]="expirationStartPicker"></mat-datepicker-toggle>
            <button matSuffix mat-icon-button aria-label="Clear expiration start date" matTooltip="Clear expiration start date" (click)="expirationStartDate.reset(); loadIndividuals()">
              <mat-icon style="color: red;">close</mat-icon>
            </button>
            <mat-datepicker #expirationStartPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field style="width: 175px;">
            <input (dateChange)="loadIndividuals()" matInput [matDatepicker]="expirationEndPicker" placeholder="Expiration End Date" [formControl]="expirationEndDate">
            <mat-datepicker-toggle matSuffix [for]="expirationEndPicker"></mat-datepicker-toggle>
            <button matSuffix mat-icon-button aria-label="Clear expiration end date" matTooltip="Clear expiration end date" (click)="expirationEndDate.reset(); loadIndividuals()">
              <mat-icon style="color: red;">close</mat-icon>
            </button>
            <mat-datepicker #expirationEndPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="5px" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="start start">
          <button mat-raised-button (click)="clearFilters()">Reset Filters</button>
          <button mat-raised-button color="primary" (click)="openApplications()">My Applications</button>
        </div>
      </div>

      <br />

      <div *ngIf="loading" style="display: flex; justify-content: center; align-items: center; min-height: 200px;">
        <mat-spinner diameter="50"></mat-spinner>
      </div>

      <div *ngIf="!loading && !individuals.length" class="empty-state">
        <mat-icon>{{ uiData.individual.icon }}</mat-icon>
        <h3>No Individuals Found</h3>
        <p>No affiliated Individuals matched the current filters. Use the Individuals applications area to start a new application.</p>
      </div>

      <mat-table *ngIf="!loading && individuals.length" [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
        <ng-container *ngFor="let cellData of individualTable.layout.container" [matColumnDef]="cellData.columnName">
          <mat-header-cell mat-sort-header *matHeaderCellDef [fxFlex]="cellData.size" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{ cellData.displayName }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [matTooltip]="getColumnText(row, cellData.columnName)" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">
            <ng-container *ngIf="cellData.type === 'status'; else individualValue">
              <div class="status-card" [ngStyle]="{'--status-color': statusColor(getStatus(row))}">
                <div *ngIf="isMobile" fxLayout="row">
                  <span><strong>{{ cellData.displayName }}: </strong></span>&nbsp;
                  <span>{{ getStatus(row) }}</span>
                </div>
                <div *ngIf="!isMobile">
                  {{ getStatus(row) }}
                </div>
              </div>
            </ng-container>
            <ng-template #individualValue>
              <div *ngIf="isMobile" fxLayout="row">
                <span><strong>{{ cellData.displayName }}: </strong></span>&nbsp;
                <span>{{ getColumnText(row, cellData.columnName) }}</span>
              </div>
              <div *ngIf="!isMobile">
                {{ getColumnText(row, cellData.columnName) }}
              </div>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef [fxFlex]="individualTable.layout.actionColumnSize" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">Actions</mat-header-cell>
          <mat-cell *matCellDef="let row" [fxFlex]="individualTable.layout.actionColumnSize" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">
            <div *ngIf="isMobile" fxLayout="row" style="display: flex; justify-content: space-between; align-items: center;">
              <span><strong>Action: </strong></span>
              <button mat-icon-button color="primary" aria-label="Open individual details" matTooltip="Open individual details" (click)="openIndividualEdit(row); $event.stopPropagation()">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </div>
            <div *ngIf="!isMobile">
              <button mat-icon-button color="primary" aria-label="Open individual details" matTooltip="Open individual details" (click)="openIndividualEdit(row); $event.stopPropagation()">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: displayedColumns" (click)="openIndividualEdit(row)" [ngClass]="sharedService.isMobile ? 'mobile-row' : ''" [ngStyle]="{'--hover-bg-color': sharedService.hoverBackgroundColor}"></mat-row>
      </mat-table>

      <br />
      <mat-paginator *ngIf="!loading && individuals.length" [pageSize]="pageSize" [pageSizeOptions]="[10, 50, individuals.length]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
    </div>
  </mat-card>
</div>